import {Type} from '@angular/core';

/**
 * A playable mini-game. `load` uses a dynamic import so the Angular build emits a
 * separate lazy chunk per game — nothing here ships in the main (or feature) bundle
 * until a game is actually picked.
 */
export interface ZenGame {
  /** Stable id used for selection/telemetry. */
  id: string;
  /** Label shown in the launcher dropdown. */
  title: string;
  /** Short tagline shown alongside the title. */
  tagline?: string;
  /** Lazily resolves the game's standalone component (its own chunk). */
  load: () => Promise<Type<unknown>>;
}

/** Single source of truth for the games library. Add a new game = add one entry. */
export const ZEN_GAMES: ZenGame[] = [
  {
    id: 'air-hockey',
    title: 'Air Hockey',
    tagline: 'Beat JenZen to 3',
    load: () =>
      import('./ice-hockey-loader/ice-hockey-loader.component').then(
        m => m.IceHockeyLoaderComponent
      )
  },
  {
    id: 'zen-man',
    title: 'Zen-Man',
    tagline: 'Eat the money, dodge the brokers',
    load: () =>
      import('./jen-zen-pacman-loader/jen-zen-pacman-loader.component').then(
        m => m.JenZenPacmanLoaderComponent
      )
  },
  {
    id: 'zenordle',
    title: 'Zenordle',
    tagline: 'Guess the energy word in 6',
    load: () =>
      import('./zenordle/zenordle.component').then(m => m.ZenordleComponent)
  },
  {
    id: 'zennections',
    title: 'Zennections',
    tagline: 'Find four groups of four',
    load: () =>
      import('./zennections/zennections.component').then(m => m.ZennectionsComponent)
  }
];
